<template>
  <div class="form-group">
    <label>{{item.title}}</label>
    <select v-if="item.type === 'select'" class="form-control"
            :multiple="item.type === 'multi_select'"
            :name="item.slug">
      <option :selected="(object && object[item.slug] && object[item.slug].toString()===x.toString())" v-for="(x,index) in item.values" :key="index" :value="x">{{item.values_lable[index]}}</option>
    </select>
    <div class="mb-1" v-if="item.type === 'multi_select'">
      <hr>
      <div v-for="(x,index) in item.values" :key="index" :value="x" class="custom-control custom-checkbox ">
        <input :value="x" autocomplete="off" type="checkbox"
               class="custom-control-input" :id="random_str+index"
               :checked="object && object[item.slug] && search(object[item.slug],x)"
               :name="item.slug+'[]'">
        <label class="custom-control-label" :for="random_str+index">{{item.values_lable[index]}}</label>
      </div>
    </div>
    <input :value="object && object[item.slug]?object[item.slug]:''" type="tel" v-else-if="item.type ==='number'" :name="item.slug" :min="item.min" :max="item.max" class="form-control">
    <input :value="object && object[item.slug]?object[item.slug]:''" type="tel"  :name="item.slug" v-else-if="item.type ==='phone'" class="form-control">
    <input :value="object && object[item.slug]?object[item.slug]:''" type="text"  :name="item.slug" v-else-if="item.type ==='short_text'" class="form-control">
    <textarea :name="item.slug" v-else-if="item.type ==='long_text'" class="form-control" v-model="log_text_val"></textarea>
    <date-input v-else-if="item.type === 'date'" :name="item.slug"  v-model="date_val"></date-input>
  </div>
</template>

<script>
import {dateInput} from "@/shared/helper";
import DateInput from "@/components/DateInput.vue";

export default {
  name: "extra-field",
  components: {
    DateInput
  },
  data()
  {
    return {
      random_str : Math.random().toString(36).substring(2, 15),
      log_text_val : '',
      date_val : '',
    }
  },
  mounted()
  {
    if (this.object && this.item.type === 'long_text' && this.object[this.item.slug])
      this.log_text_val = this.object[this.item.slug];
    if (this.object && this.item.type === 'date' && this.object[this.item.slug])
      this.date_val = dateInput(this.object[this.item.slug]);
  },
  methods:{
    search(array,item)
    {
     return (array.indexOf(item) !== -1);
    }
  },
  props:['item','object']
}
</script>

<style scoped>
.custom-control-label
{
  margin-right: 5px;
}
</style>